import { useQuery } from '@tv2/lib-graphql';
import { useRef } from 'react';
import { CombinedError, QueryDataResponse } from '@tv2/lib-graphql/core';
import { getAdobeVisitorValues } from '@tv2/lib-offspring/libs/adobe/adobeVisitor';
import { useDUID } from '@tv2/lib-offspring/hooks/useDUID';
import { PollingDocument, PollingQuery } from './__generated__/polling';

export default function useAntiSharingPolling(
  forceStop: boolean
): [
  PollingQuery['accessPolling'] | undefined,
  boolean,
  CombinedError | undefined,
  () => Promise<QueryDataResponse<PollingQuery>>,
] {
  const adobeValues = typeof window === 'undefined' ? undefined : getAdobeVisitorValues();
  const adobeHeaders = adobeValues
    ? {
        'client-platform-adobe-visitor': JSON.stringify(adobeValues),
      }
    : undefined;

  const duid = useDUID();
  const duidHeaders = duid ? { 'client-platform-duid': duid } : undefined;

  const defaultHeaders = {
    'Client-Platform-compatibility-Version': '1',
    'client-platform-timezone': new Date().getTimezoneOffset().toString(),
  };
  const initializing = useRef(true);

  const { data, refetch, fetching, error } = useQuery({
    headers: { ...adobeHeaders, ...defaultHeaders, ...duidHeaders },
    query: PollingDocument,
    requestPolicy: 'network-only',
    variables: {},
    pause: forceStop,
  });

  if (initializing.current && !fetching && data !== undefined) {
    initializing.current = false;
  }

  return [data?.accessPolling, initializing.current, error, refetch];
}
